import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';
import { useDispatch } from 'react-redux';
import {
  changeDeleteBiomarkerModalVisibility,
  changeUpdateBiomarkerModalVisibility,
  setBiomarkerToEdit,
} from '../../../../store/appSlice';
import { ListBiomarkerResponseElement } from '../../../../types/apiGeneratedTypes';

type Props = {
  biomarkerData: ListBiomarkerResponseElement;
  onToggleStatus: (biomarker: ListBiomarkerResponseElement) => void;
  isTogglingStatus?: boolean;
};

const BiomarkersTableRow = ({
  biomarkerData,
  onToggleStatus,
  isTogglingStatus = false,
}: Props) => {
  const dispatch = useDispatch();
  const isActive = biomarkerData.is_active !== false;

  const onOptionClick = (id: string, action: string) => {
    if (action === 'edit') {
      dispatch(setBiomarkerToEdit(biomarkerData));
      dispatch(changeUpdateBiomarkerModalVisibility(true));
    } else if (action === 'toggle') {
      onToggleStatus(biomarkerData);
    } else if (action === 'delete') {
      dispatch(setBiomarkerToEdit(biomarkerData));
      dispatch(changeDeleteBiomarkerModalVisibility(true));
    }
  };

  const getSummaryText = () => {
    if (biomarkerData.age_dependent) {
      return 'Age Dependent';
    }
    if (biomarkerData.lifestyle_changes) {
      return 'Lifestyle Changes';
    }
    if (biomarkerData.follow_up) {
      return 'Follow Up';
    }
    if (biomarkerData.contraindications) {
      return 'Contraindications';
    }
    if (biomarkerData.measurement_unit) {
      return `Unit: ${biomarkerData.measurement_unit}`;
    }
    return 'No Summary';
  };

  const getBloodPanelsText = () => {
    if (!biomarkerData.blood_panels || biomarkerData.blood_panels.length === 0) {
      return 'None';
    }

    const panelMap: { [key: string]: string } = {
      'core_panel': 'Core Panel',
      'repeat_panel': 'Repeat Panel',
      'plan_type': 'Plan Type'
    };

    return biomarkerData.blood_panels
      .map(panel => panelMap[panel] || panel)
      .join(', ');
  };

  return (
    <div className={`table-row biomarkers-table-row ${!isActive ? 'is-inactive' : ''}`}>
      <div className='name'>{biomarkerData.name}</div>
      { <div className='tag'>{biomarkerData.is_derived && <div className='derivedTag'>Derived</div>}</div> }
      <div className='body-systems'>
        {biomarkerData.body_systems.map((bs) => bs.title).join(', ')}
      </div>
      <div className='blood-panels'>{getBloodPanelsText()}</div>
      <div className='summary'>{getSummaryText()}</div>
      <div className='description'>{biomarkerData.description}</div>
      <div className='status'>
        <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
          {isActive ? 'Active' : 'Disabled'}
        </span>
      </div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            {
              key: 'toggle',
              value: isTogglingStatus
                ? 'Updating...'
                : isActive
                  ? 'Disable'
                  : 'Enable',
            },
            { key: 'delete', value: 'Delete' },
          ]}
          id={biomarkerData.id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default BiomarkersTableRow;
